import { useState, useEffect } from "react";
import { Form, Input, Tooltip, Button, Upload, Select } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import clanakService from "../../services/clanak.service";
import kategorijaClankaService from "../../services/kategorijaClanka.service";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import DOMPurify from "dompurify";
import { UploadOutlined, PlusOutlined } from "@ant-design/icons";
import "./EditClanak.css";
import "./AddNewClanak.css";
import "../Anketa/AddNewAnketa.css";
import { uploadImage } from "../../services/uploadImage.service";
import Background4 from "../../components/Background4";
import { useAuth } from "../../components/AuthContext";
import NotFound from "../../components/NotFound"; 
const EditClanak = () => {
  const [naslov, setNaslov] = useState("");
  const [sadrzaj, setSadrzaj] = useState("");
  const [autor, setAutor] = useState("");
  const [slika, setSlika] = useState("");
  const [datumObjave, setDatumObjave] = useState("");
  const [kategorije, setKategorije] = useState([]);
  const [kategorija, setKategorija] = useState(1);
  const [korisnikKorisnickoIme, setKorisnikKorisnickoIme] = useState("");
  const [aktivan, setAktivan] = useState(true);
  const [glavnaSlikaPreview, setGlavnaSlikaPreview] = useState("");
  const [noveGalerijskeSlike, setNoveGalerijskeSlike] = useState([]);
  const [uklonjeneSlikeIds, setUklonjeneSlikeIds] = useState([]);
  const [trenutneSlike, setTrenutneSlike] = useState([]);
  const [notFound, setNotFound] = useState(false);
    const { username } = useAuth();
  const navigate = useNavigate();
  const { id } = useParams();
  useEffect(() => {
    if (typeof slika === "string") {
      setGlavnaSlikaPreview(slika);
    }
  }, [slika]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [clanakResponse, kategorijeResponse, galerijaResponse] =
          await Promise.all([
            clanakService.getById(id),
            kategorijaClankaService.getAll(),
            clanakService.getGalerija(id),
          ]);
        setTrenutneSlike(galerijaResponse.data);
        setKategorije(kategorijeResponse.data);
        setNaslov(clanakResponse.data.naslov);
        setSadrzaj(clanakResponse.data.sadrzaj);
        setAutor(clanakResponse.data.autor);
        setSlika(clanakResponse.data.slika);
        setDatumObjave(clanakResponse.data.datumObjave);
      //  setKorisnikKorisnickoIme(clanakResponse.data.korisnikKorisnickoIme);
      setKorisnikKorisnickoIme(username);
        setAktivan(clanakResponse.data.aktivan);

        const kategorijaId =
          clanakResponse.data.kategorijaClankaId ||
          (kategorijeResponse.data.length > 0
            ? kategorijeResponse.data[0].id
            : null);
        setKategorija(kategorijaId);
      } catch (error) {
        if (error.response && error.response.status === 404) {
          setNotFound(true);
        } else {
          console.error("Greška pri učitavanju ankete:", error);
        }
      }
    };

    fetchData();
  }, [id]);

   if (notFound) return <NotFound />;
  const handleUpdateClanak = async () => {
    if (!naslov || !autor || !kategorija) {
      return;
    }

    const parser = new DOMParser();
    const doc = parser.parseFromString(sadrzaj, "text/html");
    const images = doc.querySelectorAll("img");

    for (let img of images) {
      const src = img.getAttribute("src");
      if (src.startsWith("data:")) {
        const blob = await (await fetch(src)).blob();
        const file = new File([blob], "uploaded_image.png", {
          type: blob.type,
        });
        try {
          const uploadedUrl = await uploadImage(file);
          img.setAttribute("src", uploadedUrl);
        } catch (error) {}
      }
    }

    const cleanSadrzaj = DOMPurify.sanitize(doc.body.innerHTML, {
      ALLOWED_ATTR: ["style", "class", "href", "src"],
    });

    const formData = new FormData();
    formData.append("naslov", naslov);
    formData.append("autor", autor);
    formData.append("sadrzaj", cleanSadrzaj);
    formData.append("datumObjave", datumObjave);
    formData.append("kategorijaClankaId", kategorija);
    formData.append("korisnikKorisnickoIme", korisnikKorisnickoIme);
    formData.append("aktivan", aktivan);

    if (slika instanceof File) {
      formData.append("glavnaSlika", slika);
    } else if (!slika) {
      formData.append("obrisiGlavnuSliku", "true");
    } else {
      formData.append("staraSlika", slika);
    }

    formData.append(
      "uklonjeneGalerijskeSlike",
      JSON.stringify(uklonjeneSlikeIds)
    );

    noveGalerijskeSlike.forEach((file) => {
      formData.append("noveGalerijskeSlike", file);
    });

    try {
      await clanakService.updateClanak(id, formData);
      navigate(`/zaposleni/kategorijaClanka/${kategorija}`);
    } catch (error) {}
  };

  return (
    <div>
      <Background4 />
      <div className="clanak-card">
        <Form
          layout="horizontal"
          labelCol={{ span: 5 }}
          wrapperCol={{ span: 18 }}
          className="poll-form"
        >
          <Form.Item required wrapperCol={{ span: 24, offset: 0 }}>
            <Input
              value={naslov}
              onChange={(e) => setNaslov(e.target.value)}
              placeholder="Unesite naslov članka"
              className="naslov-clanka-add"
            />
          </Form.Item>

          <Form.Item label="Ime autora">
            <Input
              value={autor}
              onChange={(e) => setAutor(e.target.value)}
              placeholder="Autor"
              className="input-field add-new-anketa-input"
            />
          </Form.Item>

          <Form.Item label="Kategorija">
            <Select
              value={kategorija}
              onChange={setKategorija}
              className="select-field add-new-anketa-select"
            >
              {kategorije.map((kategorija) => (
                <Select.Option key={kategorija.id} value={kategorija.id}>
                  {kategorija.naziv}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item label="Glavna slika">
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
              }}
            >
              <Tooltip title="Dodaj glavnu sliku">
                <UploadOutlined
                  onClick={() =>
                    document.getElementById("glavna-slika-upload").click()
                  }
                  style={{
                    fontSize: 24,
                    color: "#2a856e",
                    cursor: "pointer",
                    border: "1px dashed #2a856e",
                    padding: 8,
                    borderRadius: 6,
                  }}
                />
              </Tooltip>

              <input
                id="glavna-slika-upload"
                type="file"
                accept="image/*"
                onChange={(e) => {
                  const file = e.target.files[0];
                  if (file) {
                    const imageUrl = URL.createObjectURL(file);
                    setSlika(file);
                    setGlavnaSlikaPreview(imageUrl);
                  }
                }}
                style={{ display: "none" }}
              />

              {glavnaSlikaPreview && (
                <div style={{ marginTop: "10px" }}>
                  <img
                    src={glavnaSlikaPreview}
                    alt="Glavna slika"
                    style={{
                      width: "100px",
                      height: "100px",
                      objectFit: "cover",
                      borderRadius: "6px",
                      border: "1px solid #ddd",
                    }}
                  />
                  <Button
                    danger
                    type="link"
                    onClick={() => {
                      setSlika("");
                      setGlavnaSlikaPreview("");
                    }}
                  >
                    Ukloni sliku
                  </Button>
                </div>
              )}
            </div>
          </Form.Item>

          <Form.Item label="Aktivan">
            <Select
              value={aktivan}
              onChange={setAktivan}
              className="select-field add-new-anketa-select"
            >
              <Select.Option value={true}>Da</Select.Option>
              <Select.Option value={false}>Ne</Select.Option>
            </Select>
          </Form.Item>

          <Form.Item label="Sadržaj">
            <SunEditor
              setContents={sadrzaj}
              onChange={(content) => setSadrzaj(content)}
              setOptions={{
                height: "auto",
                buttonList: [
                  [
                    "undo",
                    "redo",
                    "bold",
                    "italic",
                    "underline",
                    "strike",
                    "list",
                    "align",
                    "fontSize",
                    "fontColor",
                    "hiliteColor",
                    "link",
                    "image",
                    "video",
                    "fullScreen",
                  ],
                ],
                imageResizing: true,
                resizingBar: true,
              }}
              onImageUploadBefore={(files, info, uploadHandler) => {
                const file = files[0];
                const reader = new FileReader();
                reader.onload = function (e) {
                  uploadHandler({
                    result: [
                      {
                        url: e.target.result,
                        name: file.name,
                        size: file.size,
                      },
                    ],
                  });
                };
                reader.readAsDataURL(file);
                return false;
              }}
            />
          </Form.Item>

          <Form.Item label="Dodaj nove slike">
            <Upload.Dragger
              accept="image/*"
              multiple
              showUploadList={false}
              beforeUpload={(file) => {
                const previewUrl = URL.createObjectURL(file);
                const novaSlika = {
                  id: Date.now() + Math.random(),
                  putanja: previewUrl,
                  file: file,
                };
                setTrenutneSlike((prev) => [...prev, novaSlika]);
                setNoveGalerijskeSlike((prev) => [...prev, file]);
                return false;
              }}
              style={{
                border: "2px dashed #39ad90",
                padding: "16px",
                borderRadius: "8px",
                textAlign: "center",
                marginBottom: "10px",
                backgroundColor: "#f2faf8",
              }}
            >
              <label
                htmlFor="galerijaUploadInput"
                style={{ cursor: "pointer" }}
              >
                <PlusOutlined
                  style={{
                    fontSize: 30,
                    color: "#39ad90",
                    border: "1px dashed #39ad90",
                    padding: 10,
                    borderRadius: "8px",
                  }}
                />
              </label>
              <p className="ant-upload-text">
                Prevucite slike ovdje ili kliknite da izaberete
              </p>
            </Upload.Dragger>

            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "10px",
                marginTop: 12,
              }}
            >
              {trenutneSlike.map((slika) => (
                <div key={slika.id} style={{ position: "relative" }}>
                  <img
                    src={slika.putanja}
                    alt="slika"
                    style={{
                      width: 100,
                      height: 100,
                      objectFit: "cover",
                      borderRadius: 4,
                    }}
                  />
                  <Button
                    danger
                    size="small"
                    onClick={() => {
                      setUklonjeneSlikeIds((prev) => [...prev, slika.id]);
                      setTrenutneSlike((prev) =>
                        prev.filter((s) => s.id !== slika.id)
                      );
                    }}
                    style={{
                      position: "absolute",
                      top: 0,
                      right: 0,
                      padding: "0 6px",
                      fontSize: 12,
                      height: 20,
                    }}
                  >
                    X
                  </Button>
                </div>
              ))}
            </div>
          </Form.Item> 
        </Form>

        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <Button
            type="primary"
            size="large"
            onClick={handleUpdateClanak}
            className="edit-clanak-button-primary"
          >
            Ažuriraj članak
          </Button>
        </div>
      </div>
    </div>
  );
};

export default EditClanak;
